export var missingParam = function missingParam(param) {
  return "Missing param: ".concat(param);
};
export var missingConfig = function missingConfig(param) {
  return "Config not found: ".concat(param);
};
export var missingControllerName = function missingControllerName(param) {
  return "Controller name  ".concat(param, " not found");
};
export default {
  missingParam: missingParam,
  missingConfig: missingConfig,
  missingControllerName: missingControllerName
};